// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1i6Hj","label":"Section_label__3gXEm","contentWrap":"Section_contentWrap__3Ucpp","footer":"Section_footer__2qsmv","footerInner":"Section_footerInner__1_ANN"};